//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "HolidaysBanner",
  data() {
    return {
      weekOffer: false
    }
  },
  computed: {
    showBottomBanner() {
      return !this.weekOffer;
    }
  },
  methods: {
    setStoreHeight() {
      const root = document.documentElement;
      root.style.setProperty('--banner-height', `${this.$refs.banner?.offsetHeight || 0}px`);
    }
  },
  beforeDestroy() {
    const root = document.documentElement;
    root.style.removeProperty('--banner-height');
  }
}
